export const getPath = (path, params) => {
    return path.replace(/:(\w+)/g, (_, paramName) => {
        return params[paramName];
    });
};
export const appendVueRoute = (name, path) => {
    return {
        path: path,
        name: name,
    };
};
//# sourceMappingURL=route-type-map.js.map